// extracted by css-extract-rspack-plugin
export default {"root":"cK62K0","item":"UxxWU7","button-wrapper":"TYUqjp","buttonWrapper":"TYUqjp","empty-state":"Ie7OBi","emptyState":"Ie7OBi"};